import { CaseInfo } from '../page/detail/data';

export const copyUrl = async (url: string = window.location.href) => {
  const decoded = decodeURI(url);
  try {
    await navigator.clipboard.writeText(decoded);
    alert('URL이 복사되었습니다!');
  } catch (err) {
    console.error('복사 실패:', err);
    // fallback
    const el = document.createElement('textarea');
    el.value = decoded;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    alert('URL이 복사되었습니다!');
  }
};

export const handleShareDetailPage = async (caseInfo: CaseInfo) => {
  const shareData = {
    title: `[${caseInfo?.branchName}]${caseInfo?.caseno}${
      caseInfo?.type === 'p'
        ? '-' + caseInfo?.itemno
        : caseInfo?.itemno.replace(/[^0-9]/g, '')
          ? ' (' + caseInfo?.itemno.replace(/[^0-9]/g, '') + ')'
          : ' (1)'
    }`,
    url: window.location.href,
  };

  const copyToClipboard = () => {
    // 클립보드 복사용
    navigator.clipboard.writeText(shareData.url).then(() => {
      window.alert({
        description: '클립보드에 복사되었습니다.',
      });
    });
  };

  if (navigator.share) {
    try {
      await navigator.share(shareData); // 링크 공유 창 띄우는 코드
    } catch (err: any) {
      if (err.name !== 'AbortError') {
        console.log(
          'Web Share API not available or failed, falling back to clipboard.',
          err.name,
        );
        copyToClipboard();
      }
    }
  } else {
    copyToClipboard();
  }
};
